import { ModuleTree } from 'vuex';
import locations from '@/store/modules/locations';
import markers from '@/store/modules/markers';
import RootState from '@/store/RootState';

const modules: ModuleTree<RootState> = {
    locations,
    markers,
};

export default modules;
